import { Button, Image, Layout, Menu, Space, theme } from "antd";
import {
  Bell,
  CalendarDays,
  Contact,
  Disc3,
  FolderTree,
  ImageIcon,
  LayoutPanelLeft,
  Music,
  Music3,
  ShieldEllipsis,
  SquareStack,
  UploadIcon,
  Wallet,
} from "lucide-react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../utils/store";

const { Header, Content, Footer, Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const items = [
  getItem("Home", "/", <LayoutPanelLeft size={16} />),
  getItem("Users", "/users", <Contact size={16} />),
  getItem("Artists", "/artists", <Music3 size={16} />),
  getItem("Genres", "/genres", <SquareStack size={16} />),
  getItem("Music", "/music", <Music size={16} />),
  getItem("Album", "/album", <Disc3 size={16} />),
  getItem("Subscription", "/subs", <CalendarDays size={16} />),
  getItem("Categories", "/categories", <FolderTree size={16} />),
  getItem("Banners", "/banners", <ImageIcon size={16} />),
  getItem("Admins", "/admins", <ShieldEllipsis size={16} />),
  getItem("Notification", "/notifications", <Bell size={16} />),
  getItem("Upload Request", "/upload-request", <UploadIcon size={16} />),
  getItem("Redeem Requests", "/redeem-requests", <Wallet size={16} />),
];

const MainLayout = ({ children }) => {
  const [collapsed, setCollapsed] = React.useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const router = useNavigate();
  const pathname = useLocation().pathname;
  const user = useAuth((state) => state.user);
  const setUser = useAuth((state) => state.setUser);
  const [currentKey, setCurrentKey] = React.useState(
    "/" + pathname.split("/")[1]
  );
  React.useEffect(() => {
    if (!user) {
      router("/login");
    }
  }, [user]);

  React.useEffect(() => {
    setCurrentKey();
  }, [pathname]);
  console.log(user);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: collapsed ? "16px 0" : "12px 0 16px 0",

            marginBottom: 16,
            borderRadius: 8,
            transition: "padding 0.2s",
          }}
        >
          <Image
            src="/logo.png"
            preview={false}
            height={60}
            style={{ objectFit: "contain" }}
          />
        </div>
        <Menu
          theme="dark"
          selectedKeys={pathname === "/" ? ["/"] : [pathname]}
          mode="inline"
          items={items}
          style={{ paddingTop: 8 }}
          onClick={({ key }) => {
            router(key);
          }}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: "#001529" }}>
          <Space style={{ float: "right", marginRight: 20 }}>
            <Button
              type="primary"
              danger
              onClick={() => {
                setUser(null);
              }}
            >
              Logout
            </Button>
          </Space>
        </Header>
        <Content>{children}</Content>
        {/* <Footer style={{ textAlign: "center" }}>Created by</Footer> */}
      </Layout>
    </Layout>
  );
};

export default MainLayout;
